/** Server-calculated centavos. Frontends format these values; never recalculate balances. */
export interface RiderFinancialSnapshot {
  rider_id: string;
  net_delivery_earnings_centavos: number;
  purchase_reimbursements_centavos: number;
  platform_commission_accrued_centavos: number;
  unpaid_obligations_centavos: number;
  overdue_centavos: number;
  pending_remittance_centavos: number;
  confirmed_payments_centavos: number;
  next_due_at: string | null;
  financial_eligible: boolean;
  financial_reason: string | null;
  recent_completed_deliveries: { order_id: string; order_public_id: number; completed_at: string | null }[];
}

export const FINANCIAL_REFETCH_INTERVAL_MS = 30_000;
export const FINANCIAL_REALTIME_TABLES = ['payment_ledger', 'remittance_submissions', 'remittance_allocations', 'rider_assignments', 'rider_financial_exemptions'] as const;

/** Missing/new-schema fields must be unavailable rather than a false zero. */
export function financialSnapshot(value: unknown): RiderFinancialSnapshot | null {
  if (!value || typeof value !== 'object') return null;
  const row = value as Record<string, unknown>;
  const money = ['net_delivery_earnings_centavos','purchase_reimbursements_centavos','platform_commission_accrued_centavos','unpaid_obligations_centavos','overdue_centavos','pending_remittance_centavos','confirmed_payments_centavos'];
  if (typeof row.rider_id !== 'string' || typeof row.financial_eligible !== 'boolean'
    || !('next_due_at' in row) || !('financial_reason' in row) || !Array.isArray(row.recent_completed_deliveries)
    || money.some((key) => row[key] == null || !Number.isSafeInteger(Number(row[key])) || Number(row[key]) < 0)) return null;
  return row as unknown as RiderFinancialSnapshot;
}
